import { get, post, put } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";

export interface ItemListadoServiciosSpa {
  id: string;
  nombre: string;
  descripcion?: string;
  precioSesion: number;
}

export const listarServiciosSpa = async (): Promise<
  ItemListadoServiciosSpa[] | undefined
> => {
  return get<ItemListadoServiciosSpa[]>(`servicios/spa`);
};

export interface NuevoServicioSpa {
  nombre: string;
  descripcion?: string;
  precioSesion: number;
}

export const crearServicioSpa = async (
  nuevoServicioSpa: NuevoServicioSpa
): Promise<undefined> => {
  return post<NuevoServicioSpa, any | undefined>(
    "servicios/spa",
    nuevoServicioSpa
  );
};

export interface ServicioSpa {
  id: string;
  nombre: string;
  descripcion?: string;
  precioSesion: number;
}

export const buscarServicioSpa = async (
  id: string
): Promise<ServicioSpa | undefined> => {
  return get<ServicioSpa>(`servicios/spa/${id}`);
};

export const QUERY_KEY_BUSCAR_SERVICIO_SPA = "buscar_servicio_spa";

export const useBuscarServicioSpa = (id?: string) => {
  if (!id) {
    throw Error("Id de servicio no definido");
  }
  return useQuery(
    [QUERY_KEY_BUSCAR_SERVICIO_SPA],
    async () => await buscarServicioSpa(id)
  );
};

export const reemplazarServicioSpa = async (servicioSpa: ServicioSpa) => {
  return put<ServicioSpa, undefined>(`servicios/spa`, servicioSpa);
};

export const QUERY_KEY_LISTAR_SERVICIOS_SPA = "QUERY_KEY_LISTAR_SERVICIOS_SPA";

export const useListarServiciosSpa = () => {
  return useQuery(
    [QUERY_KEY_LISTAR_SERVICIOS_SPA],
    async () => await listarServiciosSpa()
  );
};
